import React from 'react';
import './GeneralDocs.css'; 
import holdOn from '../assets/hold_on.png';
import holdScroll from '../assets/hold_scroll.png';
import holdIris from '../assets/hold_iris.png';
import holdLeft from '../assets/hold_left.png';

const Instructions = () => {
  return (
    <div className="docs-page-container">
      <h1>Types of Instructions</h1>
      <p> You can click the Add button of a Mode to add a new Instruction. There are 3 types of Instructions:</p>
      <ul>
        <li>
          <span className='highlight'>Key</span>: For keyboard inputs like single keys or key combinations.
        </li>
        <li>
        <span className='highlight'>Mouse</span>: For mouse inputs like left and right clicks or scrolling.
        </li>
        <li>
        <span className='highlight'>Modes</span>: To switch between Modes.
        </li>
      </ul>

      <h2>Undestanding Key Instructions</h2>
      <p>
        You can write keyboard input by typing or by clicking on the virtual keyboard symbol.
        The keyboard input can be a key or a combination of keys. A combination of keys is meant to work in a way to support shortcuts,
        that is: press the keys in order and then release all the keys.
      </p>
      <p>
        The hold option, <img src={holdOn} alt="symbol" className="inline-image hold-on" />, will make your keyboard input remain pressed.
        This is meant for specific use cases, mainly playing videogames.
        Please be aware of the potential problems that a misuse of this option can cause. You will learn more about this on the following section.
      </p>

      <h2>Continuous Instructions</h2>
      <p>
        Continuous Instructions are a set of instructions that when called will keep running forever. Once a Continous Instruction is called, 
        a yellow symbol will pop up in the main bar. 
        To stop a Continous Instruction, keep your eyes closed for a short time.
        </p>
        <p>There are currently 4 types of Continuous Instructions:</p>
      <ul className="continous-instruction-list">
        <li>
        <span> <img src={holdIris} alt="Keep left click" className="inline-image continous-instruction-image" /> GazeLead </span>
        </li>
        <li>
        <span> <img src={holdOn} alt="Keep left click" className="inline-image continous-instruction-image hold-on" /> Key input with hold </span>
        </li>
        <li>
        <span> <img src={holdScroll} alt="Scroll forever" className="inline-image continous-instruction-image" /> Scroll forever </span>
        </li>
        <li>
        <span> <img src={holdLeft} alt="Keep left click" className="inline-image continous-instruction-image" /> Keep left click </span>
           
        </li>
      </ul>
    </div>
  );
};

export default Instructions;
